<template>
	<div>
		<div class="app-bg-color-grey-dark app-border-radius-8 app-padding-30 app-flex app-flex-row-around app-text-center">
			<div>
				<ul class="app-flex app-flex-row-center">
					<li><img src="../../assets/icon/chest-yellow-2x.png" class="app-margin-right-15" /></li>
					<li class="app-font-size-40">{{ moneyInfo.kb }}</li>
				</ul>
				<p class="app-font-size-24">我的金币</p>
				<router-link to="/personal/recharge" class="app-bg-color-red app-border-radius-5 app-inline-block app-width-148 app-height-42 app-line-height-42 app-font-size-18">
					点击充值
				</router-link>
			</div>
			<div class="app-height-100 app-dashed-linear-gradient-vertical-10"></div>
			<div>
				<ul class="app-flex app-flex-row-center">
					<li><img src="../../assets/icon/diamonds-2x.png" class="app-margin-right-15" /></li>
					<li class="app-font-size-40">{{ moneyInfo.diamond }}</li>
				</ul>
				<p class="app-font-size-24">我的钻石</p>
				<div class="app-flex app-flex-row-between">
					<a
						@click="clickExchange()"
						class="app-bg-color-glod-dark app-margin-right-16 app-border-radius-5 app-inline-block app-width-118 app-height-42 app-line-height-42 app-font-size-18"
					>
						兑换
					</a>
					<router-link
						to="/personal/withdrawal"
						class="app-bg-color-red app-border-radius-5 app-inline-block app-width-118 app-height-42 app-line-height-42 app-font-size-18"
					>
						提现
					</router-link>
				</div>
			</div>
			<div class="app-height-100 app-dashed-linear-gradient-vertical-10"></div>
			<div>
				<ul>
					<li class="app-font-size-40">{{ bankList.length }}张</li>
				</ul>
				<p class="app-font-size-24">我的银行卡</p>
				<router-link to="/personal/bank/list" class="app-bg-color-red app-border-radius-5 app-inline-block app-width-148 app-height-42 app-line-height-42 app-font-size-18">
					管理
				</router-link>
			</div>
		</div>
		<!-- 兑换酷币 start -->
		<personal-exchange @handleExchange="handleExchange()" ref="personalExchange"></personal-exchange>
		<!-- 兑换酷币 end -->
		<div class="app-bg-color-grey-dark app-border-radius-8 app-padding-30 app-margin-top-30 app-font-size-18">
			<div class="filter-row" v-for="(mainItem, mainIndex) in kindList" :key="'kind-' + mainIndex">
				<label>{{ mainItem.title }}:</label>
				<ul>
					<li
						v-for="(subItem, subIndex) in mainItem.tagList"
						:key="'kind-item-' + subItem.id"
						@click="clickKind(mainItem, mainIndex, subItem, subIndex)"
						:class="formatCssClass(subItem)"
					>
						{{ subItem.title }}
					</li>
				</ul>
			</div>
			<div class="app-dashed-linear-gradient-horizontal-10"></div>
			<div class="filter-row" v-for="(mainItem, mainIndex) in typeList" :key="'type-' + mainIndex">
				<label>{{ mainItem.title }}:</label>
				<ul>
					<li
						v-for="(subItem, subIndex) in mainItem.tagList"
						:key="'type-item-' + subItem.id"
						@click="clickType(mainItem, mainIndex, subItem, subIndex)"
						:class="formatCssClass(subItem)"
					>
						{{ subItem.title }}
					</li>
				</ul>
			</div>
			<div class="app-dashed-linear-gradient-horizontal-10"></div>
			<div class="app-table-center app-margin-top-20">
				<el-table :data="recordList">
					<el-table-column prop="createTime" label="时间" width="350"></el-table-column>
					<el-table-column prop="typeText" label="类型" width="350"></el-table-column>
					<el-table-column prop="num" label="数量"></el-table-column>
				</el-table>
			</div>
		</div>
		<div class="app-pagination-container">
			<el-pagination
				v-if="pagination.total > 0"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pagination.currentPage"
				:page-sizes="pagination.pageSizeArray"
				layout=" prev, pager, next, sizes, jumper"
				:page-size="pagination.pageSize"
				:page-count="pagination.pageCount"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import service from '../../service/finance';
import personalExchange from '../../components/personal/exchange.vue';
import noData from '../../components/noData.vue';
import { mapState } from 'vuex';
export default {
	inject: ['reload'],
	data() {
		return {
			bankList: [],
			visibleExchange: false,
			recordList: [],
			searchParams: {
				moneyType: '0',
				type: '0'
			},
			pagination: {
				pageCount: 1,
				currentPage: 1,
				pageSize: 8,
				total: 0,
				pageSizeArray: [10, 20, 30, 50]
			},
			kindList: [
				{
					title: '种类',
					tagList: [
						{
							title: '金币',
							id: '0',
							selected: true
						},
						{
							title: '钻石',
							id: '1',
							selected: false
						}
					]
				}
			],
			typeList: [
				{
					title: '类型',
					tagList: [
						{
							title: '全部',
							id: '0',
							selected: true
						},
						{
							title: '收入',
							id: '1',
							selected: false
						},
						{
							title: '支出',
							id: '2',
							selected: false
						}
					]
				}
			]
		};
	},
	components: {
		noData,
		personalExchange
	},
	computed: {
		...mapState({
			moneyInfo: state => state.userAccount.account,
			userInfo: state => state.userInfo.data
		})
	},
	mounted() {
		this.getList();
		this.getBank();
	},
	updated() {
		var element = document.getElementsByClassName('el-pagination__jump');
		if (element.length > 0) {
			element[0].childNodes[0].nodeValue = '跳转';
		}
	},
	methods: {
		formatCssClass(item) {
			if (item.selected) {
				return 'tag-active';
			} else {
				return 'tag';
			}
		},
		handleExchange() {
			this.reload();
		},
		clickKind(mainItem, mainIndex, subItem, subIndex) {
			this.kindList[mainIndex].tagList.map(item => {
				item.selected = false;
			});

			this.kindList[mainIndex].tagList[subIndex].selected = true;

			this.searchParams.moneyType = subItem.id;
			this.pagination.currentPage = 1;
			this.getList();
		},
		clickType(mainItem, mainIndex, subItem, subIndex) {
			this.typeList[mainIndex].tagList.map(item => {
				item.selected = false;
			});

			this.typeList[mainIndex].tagList[subIndex].selected = true;

			this.searchParams.type = subItem.id;
			this.pagination.currentPage = 1;
			this.getList();
		},
		//兑换
		clickExchange() {
			this.$refs['personalExchange'].showDialog();
		},
		getBank() {
			service.getUserBankList(this.userInfo.id, res => {
				if (res.code === 200) {
					let list = res.data || [];
					this.bankList = list.map(item => {
						return {
							...item,
							visiblePopover: false
						};
					});
				}
			});
		},
		// 收入/支出 明细列表
		getList() {
			let params = {
				obj: {
					customerId: this.userInfo.id,
					moneyType: this.searchParams.moneyType,
					type: this.searchParams.type
				},
				query: {
					current: this.pagination.currentPage,
					size: this.pagination.pageSize
				}
			};
			service.getAwardsList(params, res => {
				if (res.code == 200 && res.success) {
					this.recordList = res.data.records.map(item => {
						let keyValue = {
							0: '充值',
							1: '购买模型',
							2: '个人分润',
							3: '平台分润',
							4: '兑换金币',
							5: '个人提现',
							6: '平台提现',
							7: '金币购买加密服务',
							8: '钻石购买加密服务',
							9: '金币续费加密服务',
							10: '钻石续费加密服务',
							11: '金币购买xr服务 ',
							12: '钻石购买xr服务',
							13: '金币续费xr服务', 
							14: '钻石续费xr服务',
							
						};
						console.log(item)
						item.typeText = keyValue[item.type];
						let moneyType = this.searchParams.moneyType;
						moneyType == 0 ? (item.num = item.kbNum) : (item.num = item.diamond);
						return item;
					});

					this.pagination.total = res.data.total;
					this.pagination.pageCount = res.data.pages;
				}
			});
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.pagination.currentPage = val;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
.filter-row {
	padding: 10px 0;
	//border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
	label {
		display: inline-block;
		float: left;
		margin: 10px 0;
		padding: 10px;
	}
	ul {
		float: left;
		li {
			cursor: pointer;
			padding: 10px 20px;
			margin: 10px;
			float: left;
			&.tag-active {
				background: #c51f4b;
				border-radius: 23px;
			}
		}
	}
	&:after {
		visibility: hidden;
		display: block;
		font-size: 0;
		content: ' ';
		clear: both;
		height: 0;
	}
}
.table {
	width: 100%;
	margin-top: 30px;
	text-align: center;
	thead {
		color: #acacac;
		tr {
			th {
				width: 33.33%;
				line-height: 40px;
			}
		}
	}
	tbody {
		tr {
			td {
				width: 33.33%;
				line-height: 50px;
			}
		}
	}
}
</style>
